<template>
<div class="home">
    <Menu v-show="!collapse"></Menu>
    <List @gotoSearch="gotoSearch" @gotoAISearch="gotoAISearch"></List>
    <div v-if="showSearch" id="toca_doc_search" class="toca_doc_search"></div>
    <!-- AI 搜索 -->
    <moo-dialog
      custom-class="ai-search-dialog"
      class="apply-dialog"
      :show-close="false"
      :visible.sync="showAISearch"
      :simple="true"
      :footer="false"
      :render-to-body="true"
      @before-close="closeAISearch"
      :destroy-on-close="true"
    >
      <div class="full-width full-height toca-wiki-ai-search">
        <div class="full-height" id="toca-wiki-ai-search"></div>
      </div>
    </moo-dialog>
  </div>
</template>

<script>
import List from "../components/List.vue";
import Menu from "../components/menu.vue";
import { mapActions, mapState } from "vuex";
import { fetchUserInfo } from "@/api/cloudHome";
import cookies from "js-cookie";
import {
  saviorEventUUID,
  updateSaviorData,
  setSaviorConfigure,
} from "../utils/savior";
import "@toca/toca-doc-web-search/dist/style.css";
import { TocaDocWebSearch } from "@toca/toca-doc-web-search";

export default {
  name: "Home",
  components: {
    List,
    Menu,
  },
  data() {
    return {
      showSearch: false,
      tocaSearch: null,
      showAISearch: false,
    };
  },
  created() {
    let env = process.env.VUE_APP_STATIC_NODE_ENV;
    if (env === "development") {
      cookies.set("deviceId", "10aba33538e2cb7f5538641fda05ef6f");
      cookies.set("token", "947c460795184ba7ba070e4754ef86be");
      cookies.set("spaceId", "0583d");
      cookies.set("userId", "154263553403101184");
      cookies.set("memberId", "213672292987805696");
    }
  },
  mounted() {
    this.initSavior();
    fetchUserInfo({
      spaceId: this.spaceId,
      userId: this.userId,
    })
      .then((res) => {
        if (res.code === 200) {
          const avatarInfo = JSON.parse(res.data.memberAvatar);

          this.setCurrentUserInfo({
            ...res.data,
            memberAvatar: avatarInfo[300],
          });

          // if (res.data.id) {
          //     cookieOptions.map((item) => {
          //         cookies.set("memberId", res.data.id, item);
          //     });
          // }
        }
      })
      .catch((err) => {});
  },
  unmounted() {
    if (this.tocaSearch) {
      this.tocaSearch.destroy();
      this.tocaSearch = null;
    }
    if (this.aiSearchChat) {
      this.aiSearchChat.destroy();
      this.aiSearchChat = null;
    }
    window.removeEventListener(
      "closeAiChatCustomEvent",
      this.handleCloseAiChatCustomEvent
    );
  },
  methods: {
    ...mapActions({
      setCurrentUserInfo: "setCurrentUserInfo",
      setHeaderTitle: "setHeaderTitle",
    }),
    initSavior() {
      if (this.isPcMode && window.setBaseData) {
        setBaseData({
          platid: "10138",
          productid: "198",
          company: "3",
        });
      }
    },
    async gotoSearch() {
      this.showSearch = true;
      let that = this;
      const cookie = {
        token: cookies.get("token"),
        spaceId: cookies.get("spaceId"),
        userId: cookies.get("userId"),
        deviceId: cookies.get("deviceId"),
        memberUniqueId: cookies.get("memberUniqueId") || this.memberId,
        memberId: cookies.get("memberId") || this.memberId,
      };
      let env = process.env.VUE_APP_STATIC_NODE_ENV;
      //   if (env === "stage") {
      //     env = "test";
      //   }
      const param = {
        env: env,
        cookies: cookie,
        isWikiHomeSearch: true,
        savior: {
          setSaviorConfigure: setSaviorConfigure,
          updateSaviorData: updateSaviorData,
        },
        customContainerClass: "cloud-home-search-custom-container-class",
        onSearchResultOpen: (url, target) => {
          console.log("-------------------onSearchResultOpen", url, target);
          window.open(url, "_blank");
        },
        onCloseSearch() {
          console.log("-------------------onCloseSearch");
          that.showSearch = false;
        },
        locale:
          this.cloudHomeI18n ||
          localStorage.getItem("tci18nLocale") ||
          navigatorLang[navigator.language] ||
          "zh-cn",
      };

      console.log("----------------------------searchParam:", param);

      //   await import("@toca/toca-doc-web-search/dist/style.css");
      //   const TocaDocWebSearchModule = await import("@toca/toca-doc-web-search");
      //   const TocaDocWebSearch = TocaDocWebSearchModule.TocaDocWebSearch;
      setTimeout(() => {
        this.tocaSearch = new TocaDocWebSearch("#toca_doc_search", param);
        // 扩展AI搜索入口
        this.appendAISearchEntryButton();
      }, 0);
    },
    gotoAISearch(searchValue = "") {
      this.showAISearch = true;
      setTimeout(() => {
        this.openAISearch(searchValue);
      }, 100);
    },
    appendAISearchEntryButton() {
      const tocaDocSearchContainer = document.getElementById("toca_doc_search");
      if (tocaDocSearchContainer) {
        const tocaDocSearchInput = tocaDocSearchContainer.querySelector(
          "input"
        );
        if (tocaDocSearchInput) {
          const div = document.createElement("div");
          div.className = "toca-wiki-ai-search-entry-append-to-input";
          // 扩展到input后面
          tocaDocSearchInput.insertAdjacentElement("afterend", div);
          // @ts-ignore
          if (window.TocaWikiAiSearchEntry) {
            // @ts-ignore
            new window.TocaWikiAiSearchEntry(div, {
              locale: 
                this.cloudHomeI18n ||
                localStorage.getItem("tci18nLocale") ||
                navigatorLang[navigator.language] ||
                "zh-cn",
              onClick: (e) => {
                e.stopPropagation();
                e.preventDefault();
                this.tocaSearch.destroy();
                this.tocaSearch = null;
                this.showSearch = false;
                const searchValue = tocaDocSearchInput.value;
                this.gotoAISearch(searchValue);
              },
            });
          }
        }
      }
    },
    openAISearch(searchValue) {
      updateSaviorData({
        eventtype: "click",
        category: "cloud_document",
        label: "doc_ai_search",
        eventid: "wiki_web_operation",
      });
      const container = document.getElementById("toca-wiki-ai-search");
      const app = document.createElement("toca-wiki-ai-chat");
      const cookie = {
        token: cookies.get("token"),
        spaceId: cookies.get("spaceId"),
        userId: cookies.get("userId"),
        deviceId: cookies.get("deviceId"),
        memberUniqueId: this.memberUniqueId || this.memberId,
        memberId: cookies.get("memberId") || this.memberId,
      };
      // @ts-ignore
      this.aiSearchChat = new TocaWikiAiChat(container, {
        defaultQuestion: searchValue,
        cookies: cookie,
        defaultOpen: true,
        fullWidth: true,
        hideHeaderTags: true,
        hidePromptSuggestions: true,
        defaultContentType: "KnowledgeSearch",
        env: process.env.VUE_APP_STATIC_NODE_ENV,
        documentId: "random" + Math.random(),
        locale: this.wikiI18n,
        saviorEventUUID: saviorEventUUID,
        setSaviorConfigure: setSaviorConfigure,
        updateSaviorData: updateSaviorData,
        aiChatShow: (isShow) => {},
      });
      this.aiSearchChat.resetCache();
      container.appendChild(app);
      window.addEventListener(
        "closeAiChatCustomEvent",
        this.handleCloseAiChatCustomEvent
      );
    },
    handleCloseAiChatCustomEvent() {
      this.aiSearchChat?.resetDefaultQuestion();
      this.showAISearch = false;
    },
    closeAISearch() {
      this.aiSearchChat?.resetDefaultQuestion();
    },
  },
  computed: {
    ...mapState({
      spaceId: (state) => state.spaceId,
      userId: (state) => state.userId,
      memberId: (state) => state.currentUserInfo.id,
      collapse: (state) => state.collapse,
      cloudHomeI18n: (state) => state.cloudHomeI18n,
      isPcMode: (state) => state.isPcMode,
    }),
  },
};
</script>

<style lang="scss">
.home {
  width: 100vw;
  height: 100vh;
  background-color: #f0f0f0;
  display: flex;
  flex-direction: row;
  overflow: hidden;

  font-family: "PingFang SC", "Avenir Next", Avenir, "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #222329;

  .toca_doc_search {
    position: fixed;
    width: 100%;
    height: 100%;
  }
}
.ai-search-dialog {
//   width: 840px !important;
//   height: 520px;
//   border-radius: 16px !important;
  overflow: auto;
  padding: 0px !important;
    display: block !important;
    margin-top: 40px !important;
    margin-bottom: 40px !important;
    height: calc(100% - 80px) !important;
    max-width: 841px !important;
    min-width: 368px !important;
    width: calc(100% - 440px) !important;
    border-radius: 20px !important;

  .full-width {
    width: 100%;
  }
  .full-height {
    height: 100%;
  }

  .moo-dialog__header {
    display: none;
  }
  .moo-dialog__body {
    height: 100%;
    padding: 0;
  }
}
.cloud-home-search-custom-container-class {
  position: relative;
  .searchInput {
    border: 1px solid #e5e5e5 !important;
    border-radius: 6px;
    padding: 0 8px;
  }
}
.toca-wiki-ai-search-entry-append-to-input {
  position: absolute;
  right: 63px;

  & > div:first-child {
    width: 120px !important;
  }
}
.toca-wiki-ai-search-entry {
    width: unset !important;
}

.toca-wiki-ai-search-entry:hover {
  background-image: linear-gradient(90deg, #d6d6ff 0%, #dfedff 100%) !important;
}
</style>
